// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"ReviewerRating_ratingContainer__soCP3","title":"ReviewerRating_title__20U3b","starGrid":"ReviewerRating_starGrid__21WlV"};